import React from 'react';
import './MediaLogos.css';

function MediaLogosEn() {
  const logos = [
    { 
      id: 1, 
      image: 'media-logo-1.png', 
      alt: 'OK Diario', 
      content: 'media-content-1.jpg',
      text: "We discuss how Tabia Group manages its clients' assets, the main operations of interest to Tabia, the sector's performance and David's international vision in asset management.",
      link: 'https://okdiario.com/economia/david-pons-27-anos-casi-2-000-millones-bajo-gestion-tabia-group-13493076'
    },
    { 
      id: 2, 
      image: 'media-logo-2.svg', 
      alt: 'Capital',
      content: 'media-content-2.jpg',
      text: 'We contribute our opinion in Capital Magazine on the housing situation after the approval of the Housing Law. Proposals and possible solutions.',
      link: 'https://capital.es/economia/inversion-inmobiliaria-y-precio-de-la-vivienda-un-callejon-sin-salida/101459/'
    },
    { 
      id: 3, 
      image: 'media-logo-3.png', 
      alt: 'Intereconomia',
      content: 'media-content-3.jpg',
      text: "Participation in the program Con I de Inmobiliario, on Radio Intereconomía, with Elena Fraile. We share Tabia Group's vision of real estate investment in Europe.",
      link: 'https://www.intereconomia.com/programa/con-i-de-inmobiliario/'
    },
    { 
      id: 4, 
      image: 'media-logo-4.jpeg', 
      alt: 'Negocios',
      content: 'media-content-4.jpg',
      text: 'Interview on Negocios Televisión with Eva Villanueva Sánchez. David Pons talks about growth projections, turnover estimates and new projects.',
      link: 'https://www.linkedin.com/posts/negocios-tv_el-secreto-del-%C3%A9xito-de-la-gesti%C3%B3n-de-patrimonio-activity-7257709190784139264-sVLO/?originalSubdomain=es'
    }
  ];

  return (
    <section className="media-logos-section">
      <div className="container">
        <p className="media-intro-text">
          At Tabia Group we have a lot to contribute. We are pleased to share our experience, opinion and vision through different media.
        </p>
        <div className="media-logos-grid">
          {logos.map((logo) => (
            <div key={logo.id} className="media-logo-container">
              <div className="media-logo-wrapper">
                <img src={`${process.env.PUBLIC_URL}/${logo.image}`} alt={logo.alt} />
              </div>
              {logo.content && (
                <div className="media-content-wrapper">
                  <img src={`${process.env.PUBLIC_URL}/${logo.content}`} alt={`${logo.alt} content`} />
                  {logo.text && <p className="media-content-text">{logo.text}</p>}
                  {logo.link && (
                    <a href={logo.link} target="_blank" rel="noopener noreferrer" className="media-content-link">
                      View full article
                    </a>
                  )}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default MediaLogosEn;
